jQuery(document).ready(function() {

// Custom JS functions

// Open Modal From URL
$('.announcementModal').attr('data-target','#announcementModal').attr('data-toggle', 'modal');


    $('.slick-content').slick({
        dots: false,
        infinite: false,
        speed: 500,
        cssEase: 'linear',
        swipeToSlide: 'true',
        autoplay: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight:true,
    });

    $('.next-slick').click(function(){
        $("#content-repeater").slick('slickNext');
    });
    $('.first-slick').click(function(){
        $("#content-repeater").slick('slickGoTo', 0);
    });

    $('.customer-logos').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            },
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 1,
            },
        }],
    });

    $('.reviews-slick').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        adaptiveHeight: false,
        autoplaySpeed: 5000,
        nextArrow: '<i class="fas fa-arrow-right"></i>',
        prevArrow: '<i class="fas fa-arrow-left"></i>',
    });

});



// WEBPACK FOOTER //
// ./scripts/mta.js